export default __webpack_public_path__ + "static/square-17616570f4bebf651665f2dec7f355db.png";